import axios from 'axios'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import StadiumRemote from '../remote/stadiumRemote'
import createDataDogLog from '../utils/datadog'

import { getSections } from '../VNDataLoadManager/Selectors'

const useGetSeats = () => {
  const [dataLoading, setLoading] = useState(false)
  const [dataSucceeded, setSuccess] = useState(false)
  const [dataFailed, setFailed] = useState(false)
  const [rows, setRows] = useState([])
  const [seats, setSeats] = useState([])

  const sections = useSelector(getSections)

  const cancelTokenRef = useRef()
  useEffect(() => {
    cancelTokenRef.current = axios.CancelToken.source()

    return () => {
      cancelTokenRef.current.cancel()
    }
  }, [])

  const getRows = (sectionName) => {
    setLoading(true)
    setSuccess(false)
    setFailed(false)
    setRows([])
    setSeats([])

    StadiumRemote.getRows(sectionName)
      .then((result) => {
        setRows(result?.data)
        setLoading(false)
        setSuccess(true)
      })
      .catch((err) => {
        if (axios.isCancel(err)) return

        const errorMessage = err?.response?.data?.errorMessage ?? ''

        createDataDogLog('error', `There was an error in retrieving rows, ERROR: ${err ?? 'No Error Sent'}`, { errorMessage })
        setLoading(false)
        setFailed(true)
      })
  }

  const getSeats = useCallback((sectionName, row) => {
    setLoading(true)
    setSuccess(false)
    setFailed(false)
    setSeats([])

    StadiumRemote.getSeats(sectionName, row)
      .then((result) => {
        setSeats(
          result?.data?.map((seat) => {
            return seat?.seat
          }),
        )
        setLoading(false)
        setSuccess(true)
      })
      .catch((err) => {
        if (axios.isCancel(err)) return

        const errorMessage = err?.response?.data?.errorMessage ?? ''

        createDataDogLog('error', `There was an error in retrieving seats, ERROR: ${err ?? 'No Error Sent'}`, { errorMessage })
        setLoading(false)
        setFailed(true)
      })
  }, [])

  return [
    getRows,
    getSeats,
    {
      sections,
      rows,
      seats,
      dataLoading,
      dataSucceeded,
      dataFailed,
    },
  ]
}

export default useGetSeats
